export function isLoggedIn() {
  try {
    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');
    return Boolean(token && userId);
  } catch {
    return false;
  }
}
